module.exports = __webpack_public_path__ + "static/media/01(2).74ad1edf.jpg";